import * as React from "react";
import { forwardRef } from "react";
const SvgRiAddLine = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "currentColor", viewBox: "0 0 24 24", width: 24, height: 24, xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11 11V5h2v6h6v2h-6v6h-2v-6H5v-2z" }));
const ForwardRef = forwardRef(SvgRiAddLine);
export default ForwardRef;
